import React from "react";
import { Card, CardBody } from "reactstrap";
import helpers from "utils/helpers";
import { useTranslation } from "context/TranslationProvider";

const OfferCard = ({ offer, orderDetails, title }) => {
  const { t } = useTranslation();
  if (!offer) return null;

  const {
    createdBy,
    isActive,
    isAccepted,
    createdAt,
    updatedAt,
  } = offer;

  const createdDate = isActive && createdAt ? helpers.getFormattedDate(createdAt, t)  : "-";
  const acceptedDate = isAccepted && updatedAt ? helpers.getFormattedDate(updatedAt, t) : "-";

  const senderUser = orderDetails?.sender_listing_id?.userId || offer.senderListing?.userId;
  const travelerUser = orderDetails?.traveler_listing_id?.userId || offer.travelerListing?.userId;

  const getUserId = (user) => {
    if (!user) return null;
    if (typeof user === "string") return user;
    return user?._id || null;
  };

  const senderUserId = getUserId(senderUser);
  const createdById = createdBy?._id || null;

  const toUser = createdById && senderUserId && String(createdById) === String(senderUserId)
    ? travelerUser
    : senderUser;

  const formatUserDisplay = (user) => {
    if (!user) return "-";
    if (typeof user === "object" && user?.firstName) {
      return `${user.firstName} ${user.lastName || ""} (${user.email || ""})`;
    }
    if (typeof user === "string") return user;
    return "-";
  };

  return (
    <Card className="shadow p-3 mb-3">
      <CardBody>
        <h5 className="mb-3 heading-md mt--3 ml--3">
          {title || t("page.orders.offerDetails.title", "Offer Details")}
        </h5>

        <div className="mb-2">
          <p className="heading-sm mb-2">
            <strong>{t("page.orders.offerDetails.sentBy", "Offer Sent By")}:</strong> {createdBy?.firstName} {createdBy?.lastName} ({createdBy?.email})
          </p>
          <p className="heading-sm mb-2">
            <strong>{t("page.orders.offerDetails.sentTo", "Offer Sent To")}:</strong> {formatUserDisplay(toUser)}
          </p>
          <p className="heading-sm mb-2">
            <strong>{t("page.orders.offerDetails.created", "Created")}:</strong> {createdDate}
          </p>
          <p className="heading-sm mb-2">
            <strong>{t("page.orders.offerDetails.accepted", "Accepted")}:</strong> {acceptedDate}
          </p>
        </div>
      </CardBody>
    </Card>
  );
};

export default OfferCard;
